export default [
  { // 0
    title: 'Whole grains',
    subtitle: 'Rice, wheat, corn and other',
    grams: 232,
    gramsMin: 232,
    gramsMax: 232,
    kcal: 811,
    weights: [
      {
        singular: 'Cup',
        plural: 'Cups',
        weight: 200,
      },
    ],
  },
  { // 1
    title: 'Starchy vegetables',
    subtitle: 'Potatoes and cassava',
    grams: 50,
    gramsMin: 0,
    gramsMax: 100,
    kcal: 39,
    weights: [
      {
        singular: 'Medium potato',
        plural: 'Medium potatoes',
        weight: 180,
      },
      {
        singular: 'Large potato',
        plural: 'Large potatoes',
        weight: 280,
      },
    ],
  },
  { // 2
    title: 'Vegetables',
    subtitle: '',
    grams: 300,
    gramsMin: 200,
    gramsMax: 600,
    kcal: 78,
    weights: [
      {
        singular: 'Small carrot',
        plural: 'Small carrots',
        weight: 75,
      },
      {
        singular: 'Medium carrot',
        plural: 'Medium carrots',
        weight: 130,
      },
      {
        singular: 'Large carrot',
        plural: 'Large carrots',
        weight: 170,
      },
    ],
  },
  { // 3
    title: 'Fruits',
    subtitle: '',
    grams: 200,
    gramsMin: 100,
    gramsMax: 300,
    kcal: 126,
    weights: [
      {
        singular: 'Small apple',
        plural: 'Small apples',
        weight: 140,
      },
      {
        singular: 'Medium apple',
        plural: 'Medium apples',
        weight: 170,
      },
      {
        singular: 'Large apple',
        plural: 'Large apples',
        weight: 210,
      },
      {
        singular: 'Banana',
        plural: 'Bananas',
        weight: 120,
      },
    ],
  },
  { // 4
    title: 'Dairy foods',
    subtitle: 'Whole milk or equivalents',
    grams: 250,
    gramsMin: 0,
    gramsMax: 500,
    kcal: 153,
    weights: [
      {
        singular: 'Cup of milk',
        plural: 'Cups of milk',
        weight: 250,
      },
    ],
  },
  { // 5
    title: 'Beef, lamb and pork',
    subtitle: '',
    grams: 14,
    gramsMin: 0,
    gramsMax: 28,
    kcal: 30,
    weights: [
      {
        singular: 'Small burger',
        plural: 'Small burgers',
        weight: 100,
      },
      {
        singular: 'Medium burger',
        plural: 'Medium burgers',
        weight: 150,
      },
      {
        singular: 'Large burger',
        plural: 'Large burgers',
        weight: 220,
      },
    ],
  },
  { // 6
    title: 'Chicken and other poultry',
    subtitle: '',
    grams: 29,
    gramsMin: 0,
    gramsMax: 58,
    kcal: 62,
    weights: [
      {
        singular: 'Small chicken breast',
        plural: 'Small chicken breasts',
        weight: 150,
      },
      {
        singular: 'Medium chicken breast',
        plural: 'Medium chicken breasts',
        weight: 225,
      },
      {
        singular: 'Large chicken breast',
        plural: 'Large chicken breasts',
        weight: 300,
      },
    ],
  },
  { // 7
    title: 'Eggs',
    subtitle: '',
    grams: 13,
    gramsMin: 0,
    gramsMax: 25,
    kcal: 19,
    weights: [
      {
        singular: 'Medium egg',
        plural: 'Medium eggs',
        weight: 50,
      },
      {
        singular: 'Large egg',
        plural: 'Large eggs',
        weight: 60,
      },
    ],
  },
  { // 8
    title: 'Fish',
    subtitle: '',
    grams: 28,
    gramsMin: 0,
    gramsMax: 100,
    kcal: 40,
    weights: [
      {
        singular: 'Small salmon fillet portion',
        plural: 'Small salmon fillet portions',
        weight: 110,
      },
      {
        singular: 'Large salmon fillet portion',
        plural: 'Large salmon fillet portions',
        weight: 175,
      },
      {
        singular: 'Whole side of salmon',
        plural: 'Whole sides of salmon',
        weight: 1200,
      },
    ],
  },
  { // 9
    title: 'Legumes',
    subtitle: '',
    grams: 75,
    gramsMin: 0,
    gramsMax: 100,
    kcal: 284,
    weights: [
      {
        singular: 'Cup',
        plural: 'Cups',
        weight: 200,
      },
    ],
  },
  { // 10
    title: 'Nuts',
    subtitle: '',
    grams: 50,
    gramsMin: 0,
    gramsMax: 75,
    kcal: 291,
    weights: [
      {
        singular: 'Cup',
        plural: 'Cups',
        weight: 150,
      },
    ],
  },
  { // 11
    title: 'Unsaturated oils',
    subtitle: '',
    grams: 40,
    gramsMin: 20,
    gramsMax: 80,
    kcal: 354,
  },
  { // 12
    title: 'Saturated oils',
    subtitle: '',
    grams: 11.8,
    gramsMin: 0,
    gramsMax: 11.8,
    kcal: 96,
  },
  { // 13
    title: 'Added sugars',
    subtitle: '',
    grams: 31,
    gramsMin: 0,
    gramsMax: 31,
    kcal: 120,
    weights: [
      {
        singular: 'Teaspoon',
        plural: 'Teaspoons',
        weight: 4,
      },
    ],
  },
];
